export const FETCH_SESSION = 'FETCH_SESSION'

export const RECEIVE_SESSION = 'RECEIVE_SESSION'

export const RESET_SESSION = 'RESET_SESSION'

export const RECEIVE_PRE_LOGIN = 'RECEIVE_PRE_LOGIN'

export const RECEIVE_LOGIN = 'RECEIVE_LOGIN'

export const RECEIVE_SESSION_ERROR = 'RECEIVE_SESSION_ERROR'

export const RESET_SESSION_ERROR = 'RESET_SESSION_ERROR'
